export default __webpack_public_path__ + "static/media/icon_button_add.2b2b1ad7.svg";